<div class="flex w-full items-start gap-2">
  <textarea
    matInput
    #field_name
    [(ngModel)]="value"
    [spellcheck]="false"
    class="min-w-0 flex-grow"
    aria-label="GeoJSON"
    aria-multiline="true"
    (input)="onInput($event)"
    (blur)="blur()"
    (focus)="focus()"></textarea>
  <button
    type="button"
    mat-icon-button
    class="map-designer-open-button shrink-0"
    aria-label="Open map editor"
    matTooltip="Open map editor"
    (click)="openDialog()">
    <fa-icon [icon]="['fal','draw-square']"></fa-icon>
  </button>
</div>
